import React, { Component } from 'react'
import { NavBar, Springboard, Main } from 'components'

class App extends Component {
	render() {
		return (
			<div className='container-fluid'>
				<NavBar />
				<Springboard />
				<Main />
			</div>
		)
	}
}

export default App



// WEBPACK FOOTER //
// ./src/containers/ui/App.js